import { createDecorator } from 'vue-class-component';
import { calmComputed } from "../../../lib/utils/vue/vueCalmComputed";
// @ts-ignore 检查reflect-metadata是否安装
const reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
// 从vue-property-decorator里抄来的 配合reflect-metadata使用可以从ts类型上自动推断type
function applyMetadata(options, target, key) {
  if (reflectMetadataIsSupported) {
    if (!Array.isArray(options) && typeof options !== 'function'
    // eslint-disable-next-line no-prototype-builtins
    && !options.hasOwnProperty('type') && typeof options.type === 'undefined') {
      // @ts-ignore reflectMetadataIsSupported===true时一定有Reflect.getMetadata
      const type = Reflect.getMetadata('design:type', target, key);
      if (type !== Object) {
        options.type = type;
      }
    }
  }
}
export function executeDefaultValue(options) {
  if ((options === null || options === void 0 ? void 0 : options.type) === Array && typeof (options === null || options === void 0 ? void 0 : options.default) === 'function') {
    return options === null || options === void 0 ? void 0 : options.default();
  }
  return options === null || options === void 0 ? void 0 : options.default;
}
// 使用方法 下面的代码片段 part1 part2 完全等效
// part1 (配合reflect-metadata可以把type推断自动在ts中完成 进一步缩减)
// @VueCalmComputedData(
//   'internalDropHintRects',
//   (a, b) => (a && b) && a.length === b.length,
//   { default: [], type: Array },
// )
// declare dropHintRects: (RectLike | null)[] ;
// part2
// internalDropHintRects = [] as (RectLike | null)[];
// @CalmComputedGetter((a, b) => (a && b) && a.length === b.length)
// get dropHintRects() {
//   return this.internalDropHintRects;
// }
// set dropHintRects(value) {
//   this.internalDropHintRects = value;
// }
/**
 * 将一个declare声明的变量 包装为getter setter 并使用calmComputed包装
 * 需要使用declare声明你的变量
 * @param dataName 内置data中的变量名用来存储实际值
 * @param  equalFn calmComputed的cmp函数
 * @param options options {type:xxx,default:xxx}
 * @return PropertyDecorator
 */
export function VueCalmComputedData(dataName, equalFn, options) {
  return (target, key) => {
    // 从vue-property-decorator里抄来的 配合reflect-metadata使用可以从ts类型上自动推断type
    applyMetadata(options, target, key);
    createDecorator((componentOptions, k) => {
      // 将dataName写入data中
      (componentOptions.mixins || (componentOptions.mixins = [])).push({
        data() {
          return {
            [dataName]: executeDefaultValue(options)
          };
        }
      });
      // 自定义getter setter
      (componentOptions.computed || (componentOptions.computed = {}))[k] = {
        get: calmComputed(function () {
          return this[dataName];
        }, equalFn),
        set(value) {
          this[dataName] = value;
        }
      };
    })(target, key);
  };
}
//# sourceMappingURL=vueCalmComputedData.js.map
